import request from '../request'

export function addCategoryApi(params: any) {
  return request.post('/admin/source_group', params)
}

export function deleteCategoryApi(id: number | string) {
  return request.delete(`/admin/source_group/${id}`)
}